
import styled from "styled-components";

export const HeaderTitle = styled.h1`
  font-weight: 800;
  line-height: 1.3;
  letter-spacing: -0.5px;
  margin-bottom: 20px;
  
  /* Mobile phone styles */
  font-size: 40px;
  
  /* Small tablet styles */
  @media (min-width: 480px) {
    font-size: 40px;
  }
  
  /* Large tablet styles */
  @media (min-width: 768px) {
    font-size: 48px;
    letter-spacing: -1px;
  }
  
  /* Desktop styles - match original h1 dimensions */
  @media (min-width: 1024px) {
    font-size: 60px; /* font60 equivalent */
    letter-spacing: -1.2px;
  }
`;


export const Wrapper = styled.section`
  padding-top: 20px;
  width: 100%;
  min-height: 840px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;
export const LeftSide = styled.div`
  width: 50%;
  height: 100%;
  margin-top: -120px;
  @media (max-width: 960px) {
    width: 100%;
    order: 2;
    margin-top: 75px;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 75px 0 50px 0;
  }
`;
export const RightSide = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    margin-top: 75px;
  }
`;
export const HeaderP = styled.div`
  max-width: 470px;
  padding: 15px 0 30px 0;
  line-height: 2.3rem;
  @media (max-width: 960px) {
    padding: 15px 0 10px 0;
    text-align: center;
    max-width: 100%;
    line-height: 1.8rem;
  }
`;
export const BtnWrapper = styled.div`
  max-width: 190px;
  @media (max-width: 960px) {
    margin: 0 auto;
  }
`;
export const GreyDiv = styled.div`
  width: 30%;
  height: 700px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
  @media (max-width: 960px) {
    display: none;
  }
`;
export const ImageWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  z-index: 9;
  @media (max-width: 960px) {
    width: 100%;
    justify-content: center;
  }
`;
export const Img = styled.img`
  @media (max-width: 560px) {
    width: 100%;
    height: 100%;
  }
`;
export const QuoteWrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 50px;
  max-width: 330px;
  padding: 30px;
  z-index: 99;
  @media (max-width: 960px) {
    left: 20px;
  }
  @media (max-width: 560px) {
    bottom: 5px;
  }
`;
export const QuotesWrapper = styled.div`
  position: absolute;
  left: -20px;
  top: -10px;
`;
export const DotsWrapper = styled.div`
  position: absolute;
  right: -100px;
  bottom: 100px;
  z-index: 2;
  @media (max-width: 960px) {
    right: 100px;
  }
  @media (max-width: 560px) {
    display: none;
  }
`;
